module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isReady) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.hasRegister) ? _c('navbar-e', {
    attrs: {
      "userInfo": _vm.userInfo,
      "type": (_vm.$agency.isHQHotel || _vm.$agency.isHotel) ? 'IRS' : 'HQ',
      "activeMenu": "crm"
    }
  }) : _c('NavBar'), _vm._v(" "), (!_vm.hasPermission) ? _c('iframe', {
    attrs: {
      "src": "/account-web/empty.html",
      "frameborder": "0",
      "width": "100%",
      "height": "660"
    }
  }) : _c('div', {
    staticClass: "body-content"
  }, [_c('SideNav', {
    attrs: {
      "menus": _vm.menus
    }
  }), _vm._v(" "), _c('BreadCrumb'), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "fixWrapperBox"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "havpv-incorrect-wrapper"
  }, [(_vm.count) ? _c('p', [_vm._v("尊敬的商户：您好，有"), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.exportHotel
    }
  }, [_vm._v(" " + _vm._s(_vm.count) + " ")]), _vm._v("家门店还未登录收银POS，您暂时不能使用会员营销模块。请门店先安装并登录收银POS。")]) : _c('p', [_vm._v("尊敬的商户：您好，您还未登录收银POS，暂时不能使用会员营销模块。请先安装并登录收银POS。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "15px 0 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下载安装")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.PVIncorrect && !_vm.$agency.isHQ) ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('MessageNav'), _vm._v(" "), _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "content-inner-wrapper"
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.componentName
    }
  }, [_c('router-view')], 1)], 1)])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxHeader"
  }, [_c('span', {
    staticClass: "important"
  }, [_vm._v("温馨提示")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pv-incorrect-wrapper"
  }, [_c('p', {
    staticClass: "important"
  }, [_vm._v("重要提示：")]), _vm._v(" "), _c('p', [_vm._v("您门店的收银POS版本与云后台不一致，请登录官网下载CRM专用安装包。")]), _vm._v(" "), _c('p', [_vm._v("请点击链接："), _c('a', {
    attrs: {
      "href": "http://www.passiontec.cn/passiontec-official/windows",
      "target": "_blank"
    }
  }, [_vm._v("http://www.passiontec.cn/passiontec-official/windows")]), _vm._v("，在windows版下载中选择CRM版本。")]), _vm._v(" "), _c('p', [_vm._v("如有问题，请拨打客服电话：400-060-0809")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e795e3e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 843
// module chunks = 11